import { useState } from 'react';
import { SliderSettings } from '../../types/slider';
import { Button } from '../base/Button';

interface SettingsPanelProps {
  settings: SliderSettings;
  onSave: (settings: SliderSettings) => void;
}

export const SettingsPanel = ({ settings, onSave }: SettingsPanelProps) => {
  const [localSettings, setLocalSettings] = useState<SliderSettings>(settings);

  const handleSave = () => {
    onSave(localSettings);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">スライダー設定</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            ハンドルカラー
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={localSettings.handleColor}
              onChange={(e) => setLocalSettings({ ...localSettings, handleColor: e.target.value })}
              className="w-12 h-10 rounded-lg border border-gray-300 cursor-pointer"
            />
            <input
              type="text"
              value={localSettings.handleColor}
              onChange={(e) => setLocalSettings({ ...localSettings, handleColor: e.target.value })}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            ハンドルサイズ: {localSettings.handleSize}px
          </label>
          <input
            type="range"
            min="32"
            max="80"
            step="4"
            value={localSettings.handleSize}
            onChange={(e) => setLocalSettings({ ...localSettings, handleSize: Number(e.target.value) })}
            className="w-full cursor-pointer"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            区切り線の幅: {localSettings.dividerWidth}px
          </label>
          <input
            type="range"
            min="2"
            max="8"
            step="1"
            value={localSettings.dividerWidth}
            onChange={(e) => setLocalSettings({ ...localSettings, dividerWidth: Number(e.target.value) })}
            className="w-full cursor-pointer"
          />
        </div>
      </div>
      
      <Button variant="primary" onClick={handleSave} className="w-full">
        設定を保存
      </Button>
    </div>
  );
};
